import { useEffect, useState } from "react";
import { formatJaTime } from "./jamaicaTime";

/** Read-only sidecar monitor. Mounted on the MT5 tab (moved from Info 2026-10-13). */
export default function Mt5EaLab({ token }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let live = true;
    const refresh = async () => {
      try {
        const response = await fetch("/api/mt5-ea-lab/status", {
          headers: token ? { "Authorization": "Bearer " + token } : {}, cache: "no-store",
        });
        if (!response.ok) throw new Error(`Status unavailable (${response.status})`);
        const result = await response.json();
        if (live) { setData(result); setError(""); }
      } catch (err) { if (live) setError(err.message); }
    };
    refresh();
    const timer = setInterval(refresh, 20000);
    return () => { live = false; clearInterval(timer); };
  }, [token]);
  const outer = { background: "#1a1a26", border: "1px solid #2a2a3a", borderRadius: 10, padding: 20 };
  const line = { margin: "8px 0", color: "#bbbbcc", overflowWrap: "anywhere" };
  const age = data?.updated_utc ? Date.now() - new Date(data.updated_utc).getTime() : Infinity;
  return <section style={outer} aria-label="MT5 EA research progress">
    <h3 style={{ color: "#f5a623", marginTop: 0 }}>🧪 MT5 EA Lab — research only</h3>
    <p style={line}>Independent PC tester. No EA activation, orders, scanner/risk-config edits or funded-account promotion.</p>
    {error && <p role="alert" style={{ color: "#ef4444" }}>{error}</p>}
    {!data ? <p style={line}>Waiting for first research cycle…</p> : <>
      <p style={line}><strong>Phase:</strong> {data.phase || "unknown"}{age > 7200000 ? " · STALE (>2 hours)" : ""}</p>
      <p style={line}><strong>Activity:</strong> {data.message || "None"}</p>
      <p style={line}><strong>Candidate:</strong> {data.expert || "Unassigned"} · {data.symbol || "—"} {data.timeframe || ""}</p>
      <p style={line}><strong>Tester window:</strong> {data.from_date || "—"} → {data.to_date || "—"} (UTC; history coverage unverified)</p>
      <p style={line}><strong>Updated:</strong> {data.updated_utc ? formatJaTime(data.updated_utc) : "—"} Jamaica time</p>
      <p style={line}><strong>Next:</strong> {data.next_step || "Awaiting manual review"}</p>
      <p style={{ ...line, color: "#f5a623" }}>FundedNext compliance: {data.gates?.fundednext_compliance || "not verified"}; live trading: disabled.</p>
      {data.metrics && <p style={line}><strong>Raw reported metrics (not independently certified):</strong> {JSON.stringify(data.metrics)}</p>}
    </>}
  </section>;
}
